import React from 'react'
import { Form, Input, Button, Checkbox, Select } from 'antd'
import { ThunderboltOutlined } from '@ant-design/icons'
import { DESCRIPCION_CORRECTA_MAX_LENGTH } from '../utils/formUtils'

const { TextArea } = Input

/**
 * Sección de descripción del formulario
 */
const DescripcionSection = ({
  form,
  material,
  isReadOnly,
  loadingTextoBreve,
  descripcionUrgente,
  descripcionBreveIA,
  descripcionBreveIAModificada,
  camposFaltantes,
  requiereActualizacionCatalogo,
  getFieldValidation,
  onGenerarTextoBreve,
  onDescripcionBreveChange,
  onDescripcionCorrectaChange,
  onDescripcionUrgenteChange,
  onRequiereActualizacionCatalogoChange,
  onCampoChange,
}) => (
    <>
      <Form.Item 
        label={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>Descripción Breve</span>
            <Button
              type="text"
              size="small"
              icon={<ThunderboltOutlined />}
              loading={loadingTextoBreve}
              disabled={
                isReadOnly ||
                !form.getFieldValue('descripcionCorrecta') ||
                form.getFieldValue('descripcionCorrecta')?.length < 5
              }
              onClick={onGenerarTextoBreve}
              style={{
                padding: '0 4px',
                height: '20px',
                color: '#1890ff',
              }}
              title="Generar texto breve automáticamente"
            />
          </div>
        }
        name="descripcionBreve"
        {...getFieldValidation('descripcionBreve')}
      >
        <TextArea
          rows={2}
          placeholder="Ingrese descripción breve"
          style={{ resize: 'none' }}
          disabled={isReadOnly}
          onChange={onDescripcionBreveChange}
        />
      </Form.Item>
      
      <Form.Item
        label={
          <span>
            Descripción Correcta{' '}
            <span style={{ color: '#888', fontSize: '12px', fontWeight: 'normal' }}>
              | {material.repuesto_descripcion}
            </span>
          </span>
        }
        name="descripcionCorrecta"
        {...getFieldValidation('descripcionCorrecta')}
      >
        <TextArea
          rows={2}
          placeholder={`Ingrese descripción correcta (máx. ${DESCRIPCION_CORRECTA_MAX_LENGTH})`}
          style={{
            resize: 'none',
            color: descripcionUrgente ? 'red' : undefined
          }}
          disabled={isReadOnly}
          maxLength={DESCRIPCION_CORRECTA_MAX_LENGTH}
          showCount
          onChange={onDescripcionCorrectaChange}
        />
      </Form.Item>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <p>Cambio de Descripción ?</p>{' '}
        <Checkbox
          disabled 
          checked={
            material.repuesto_descripcion !==
            material.revision_descripcion_correcta
          }
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <p>Descripción correcta urgente ?</p>{' '}
        <Checkbox
          disabled={isReadOnly}
          checked={descripcionUrgente}
          onChange={onDescripcionUrgenteChange}
        />
      </div>

      <Form.Item label="Actualización Catálogo" style={{ marginTop: 8 }}>
        <Select
          value={requiereActualizacionCatalogo}
          onChange={onRequiereActualizacionCatalogoChange}
          disabled={isReadOnly}
          placeholder="Seleccione"
          options={[
            { value: 0, label: 'No' },
            { value: 1, label: 'Sí' },
          ]}
        />
      </Form.Item>
    </>
  )

export default DescripcionSection
